import React from 'react';
import Tag from './Tag';
import { fmtDateISO, fmtTime, safeParseDate, typeAccent, money } from '../utils';

export default function ActivityRow({ a, onView }) {
  const d = safeParseDate(a.at);
  return (
    <button type="button" className="row" onClick={() => onView(a.id)}>
      <div className="rowL">
        <div className="rowDot" style={{ background: typeAccent(a.type) }} />
        <div className="rowMain">
          <div className="rowTitle">{a.title}</div>
          <div className="rowSub">
            <span className="muted">{fmtDateISO(d)}</span>
            <span className="sep">•</span>
            <span className="muted">{fmtTime(d)}</span>
            {a.amount != null ? <><span className="sep">•</span><span className="money">{money(a.amount, a.currency)}</span></> : null}
          </div>
        </div>
      </div>
      <div className="rowR">
        <Tag t={a.type} />
        <span className="rowHint">View</span>
      </div>
    </button>
  );
}
